var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"missionName",staticClass:"mission-name"},[_c('span',[_vm._v("Misja:")]),_c('p',[_vm._v(" "+_vm._s(_vm.missionName)+" "),_c('span',{staticClass:"gamename"},[_vm._v(_vm._s(_vm.missionTitle))])])])}
var staticRenderFns = []

export { render, staticRenderFns }